export default "__VITE_ASSET__CYk5UeW8__"